import * as types from "./mutation-types";

export default {
  // is required
  [types.CLIENT_ID_SUCCESS](state, clientId) {
    state.clientId = clientId;
  },
  [types.CLIENTNAME](state, clientName) {
    state.clientName = clientName;
  },
  // need check if this mutations are necessary
  [types.ADD_STUDY](state, obj) {
    state.newStudy = obj.body;
    // window.localStorage.setItem('new_study', JSON.stringify(obj.body));
  },
  [types.ADD_QUESTION](state, obj) {
    state.newQuestion = obj;
  },
  [types.UPDATE_PROFILE](state, obj) {
    state.updatedProfileData = obj;
  },
  [types.SELECTED_QUESTION](state, obj) {
    state.selectedQuestion = obj;
  },
  [types.FORGOT_PASSWORD_ERROR](state, obj) {
    state.forgotPassword = { name: obj.username };
  },
  [types.FORGOT_PASSWORD_SUCCESS](state, obj) {
    state.forgotPassword = { name: obj.username };
  },
  [types.SEND_OTP_SUCCESS](state, obj) {
    state.sendOtp = { name: obj.token };
  },
  [types.SEND_OTP_ERROR](state, obj) {
    state.sendOtp = { name: obj.token };
  },
  [types.CONFIRM_OTP_SUCCESS](state, obj) {
    state.sendOtp = { token: obj.token, otp: obj.otp };
  },
  [types.CONFIRM_OTP_ERROR](state, obj) {
    state.sendOtp = { token: obj.token, otp: obj.otp };
  },
  [types.SURVEY_DETAILS](state, obj) {
    state.surveyDetails = obj;
  },
  [types.SELECTED_FEATURES](state, obj) {
    state.selectedFeatures = obj;
  },
  [types.ADD_CONSENT_SECTION](state, obj) {
    state.addedConsentSection = obj;
  },
  [types.ADD_OPTIONAL_CONSENT_SECTION](state, obj) {
    state.addedOptionalConsentSection = obj;
  },
  [types.ADD_CONSENT_QUIZ](state, obj) {
    state.addedConsentQuiz = obj;
  },
  [types.ADD_OPTIONAL_CONSENT_QUIZ](state, obj) {
    state.addedOptionalConsentQuiz = obj;
  },
  [types.ADD_SCHEDULE](state, obj) {
    state.schedulerObj = obj;
  },
  [types.SURVEY_QUESTIONS](state, obj) {
    state.surveyQuestions = obj;
  },
  [types.SIGNATURE_STATUS](state, obj) {
    state.signatureStatus = obj;
  },
  [types.SAVE_SIGNATURE](state, obj) {
    state.signatureData = obj;
  },
  [types.CANCLE_COHORT_EDITING](state, obj) {
    state.cancelAssociationEditing = obj;
  },
  [types.TELEHEALTH_VISIT](state, obj) {
    state.telehealthVisitObj = obj;
  },
  [types.VIDEO_CALL_STATUS](state, value) {
    state.videoCallStatusValue = value;
  },
  [types.TELEHEALTH_APPOINTMENT_DURATION](state, value) {
    state.telehealthAppointmentDuration = value;
  },
  [types.STATIC_URL](state, value) {
    state.staticUrl = value;
  },
  [types.IS_PUBLISH_DISABLED](state, value) {
    state.isPublishDisabled = value;
  },
  [types.IS_PREVIEW_DISABLED](state, value) {
    state.isPreviewDisabled = value;
  },
  [types.IS_RWEB_PREVIEW_DISABLED](state, value) {
    state.getIsRwebPreviewDisable = value;
  },
  [types.SET_PUBLISH_TAB](state, value) {
    state.isPublishTab = value;
  },
  [types.ACTIVITY_ROWS](state, obj) {
    state.activityRows = obj;
  },
  [types.ACTIVITY_DETAILS](state, obj) {
    state.activityDetails = obj;
  },
  [types.ACTIVITY_QUESTIONS](state, obj) {
    state.activityQuestions = obj;
  },
  [types.ADD_ACTIVITY_QUESTION](state, obj) {
    state.newActivityQuestion = obj;
  },
  [types.SELECTED_ACTIVITY_QUESTION](state, obj) {
    state.selectedActivityQuestion = obj;
  },
  [types.SET_LAST_MODIFIED_ACTIVITY_QUESTION](state, obj) {
    state.lastModifiedActivityQuestion = obj;
  },
  [types.SAVE_BASE_64_SIGNATURE](state, obj) {
    state.base64SignatureData = obj;
  },
  [types.SAVE_BASE_64_INITIAL](state, obj) {
    state.base64InitialData = obj;
  },
  /** Participants Portal - START */
  [types.PARTICIPANTS_PORTAL_GLOBAL_ELEMENTS](state, obj) {
    state.participantsPortalGlobalElements = obj;
  },
  [types.PARTICIPANTS_PORTAL_CONFIG](state, obj) {
    state.participantsPortalConfig = obj;
  },
  [types.PARTICIPANTS_PORTAL_LANGUAGES](state, obj) {
    state.participantsPortalLangages = obj;
  },
  [types.PARTICIPANTS_PORTAL_LANGUAGE_TRANSLATION](state, obj) {
    state.participantsPortalLangageTranslation = obj;
  },
  [types.PARTICIPANTS_PORTAL_STRINGS](state, obj) {
    state.participantsPortalStrings = obj;
  },
  [types.PARTICIPANTS_PORTAL_BITRISE_DATA](state, obj) {
    state.participantsPortalBitriseData = obj;
  },
  [types.PARTICIPANTS_PORTAL_STUDY_DATA](state, obj) {
    state.participantsPortalStudyData = obj;
  },
  [types.PARTICIPANTS_SELECTED_ACTIVITY](state, obj) {
    state.participantsSelectedActivity = obj;
  },
  [types.PARTICIPANTS_ADHERENCES](state, obj) {
    state.participantAdherences = obj;
  },
  [types.PARTICIPANTS_TASK_SCHEDULES](state, obj) {
    state.participantTaskSchedules = obj;
  },
  [types.PARTICIPANTS_STUDY_TASK_SCHEDULES](state, obj) {
    state.participantStudyTaskSchedules = obj;
  },
  [types.PARTICIPANTS_LANGUAGES](state, obj) {
    state.participantsLanguages = obj;
  },
  [types.PARTICIPANTS_STUDY_VIDEOS](state, obj) {
    state.participantsStudyVideos = obj;
  },
  [types.PARTICIPANTS_COUNTRIES](state, obj) {
    state.participantsCountries = obj;
  },
  [types.PARTICIPANTS_PORTAL_CONSENT_DATA](state, obj) {
    state.participantsPortalConsentData = obj;
  },
  [types.PARTICIPANTS_PORTAL_DETAILS](state, obj) {
    state.participantsPortalDetails = obj;
  },
  [types.PARTICIPANTS_TELEHEALTH_VIDOCALL_DETAILS](state, obj) {
    state.participantsTelehealthVideoCallDetails = obj;
  },
  [types.PARTICIPANTS_APPOINTMENT_STATUS](state, obj) {
    state.participantsAppointmentStatus = obj;
  },
  [types.PARTICIPANTS_ACTIVITY_TRANSLATION](state, obj) {
    state.participantsActivityTranslation = obj;
  },
  [types.SELECTED_ACTIVITY](state, obj) {
    state.selectedActivity = obj;
  },
  /** Participants Portal - END */
  [types.AWS_COGNITO_AUTHENTICATION](state, value) {
    state.awsCognitoAuthentication = value;
  },
  [types.PWEB_COGNITO_AUTHENTICATION](state, value) {
    state.pwebCognitoAuthentication = value;
  },
  [types.CSSR_ACTIVTY_LANGUAGE](state, obj) {
    state.activityCSSRLangages = obj;
  },
  [types.SSO_LOGIN_URL](state, value) {
    state.ssoLoginURL = value;
  },
  [types.SSO_POOL_CLIENT](state, value) {
    state.ssoPoolClient = value;
  },
  /** Dynamic Activity Scheduling - Start */
  [types.STORE_CONSTANT_DYNAMIC_ACTIVITY_SCHEDULES](state, obj) {
    state.constantDynamicActivitySchedulesData = obj;
  },
  [types.STORE_DYNAMIC_ACTIVITY_SCHEDULES](state, obj) {
    state.dynamicActivitySchedulesData = obj;
  },
  [types.EDIT_SELECTED_DYNAMIC_ACTIVITY_SCHEDULE](state, obj) {
    state.editSelectedDynamicActivityScheduleData = obj;
  },
  [types.DYNAMIC_SCHEDULE_CONFIGURED_TRIGGERS_DATA](state, obj) {
    state.configuredTriggersData = obj;
  },
  [types.DYNAMIC_SCHEDULE_CONFIGURED_ACTIONS_DATA](state, obj) {
    state.configuredActionsData = obj;
  },
  [types.DYNAMIC_SCHEDULING_SERVICE](state, obj) {
    state.dynamicSchedulingService = obj;
  },
  /** Dynamic Activity Scheduling - End */
  [types.DATE_RANGE_VIEW_ENABLED](state, value) {
    state.isDateRangeEnabled = value;
  },
  [types.STUDY_TOGGLED_FEATURES](state, obj) {
    state.studyToggledFeatures = obj;
  },
  [types.STUDY_TOGGLED_FEATURES](state, obj) {
    state.studyToggledFeatures = obj;
  },
  [types.MULTI_FACTOR_AUTH_ENABLED](state, obj) {
    state.multiFactorAuthEnabled = obj;
  },
  [types.SITE_DETAILS_DATA](state, obj) {
    state.siteDetailsData = obj;
  },
  [types.WEB_SOCKET_SERVICE_DATA](state, obj) {
    state.webSocketServiceData = obj;
  }
};
